import { Box, Button } from '@chakra-ui/react';

// Code icon
const CodeIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polyline points="16 18 22 12 16 6" />
    <polyline points="8 6 2 12 8 18" />
  </svg>
);

interface IFloatingCodeButtonProps {
  onClick: () => void;
}

/**
 * Floating button shown in preview-only mode to switch to an editor layout.
 */
const FloatingCodeButton = ({ onClick }: IFloatingCodeButtonProps) => {
  return (
    <Box
      position="absolute"
      bottom={4}
      left={4}
      zIndex={100}
    >
      <Button
        leftIcon={<CodeIcon />}
        size="sm"
        bg="#252535"
        color="white"
        border="1px solid"
        borderColor="whiteAlpha.200"
        boxShadow="0 4px 20px rgba(0,0,0,0.4)"
        _hover={{
          bg: 'purple.500',
          borderColor: 'purple.500',
        }}
        _active={{
          bg: 'purple.600',
        }}
        onClick={onClick}
      >
        Edit Code
      </Button>
    </Box>
  );
};

export default FloatingCodeButton;
